import React, {useState, useEffect} from 'react';
import Globals, { URLS } from '../../utility/constants/appConstants';
import Storage from '../../utility/features/helpers/storageHelper';

const ErrorMessage = (props) => {
    const labels = Globals;

    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        if(props.errMsg && props.errMsg != ""){
            setMessage(props.errMsg);
            setIsError(true);
        }

        const resettoken_loggedin = JSON.parse(localStorage.getItem('loggedin_resetToken'));
    }, []);

    const { errTitle, isSavePrefError } = props;

    return (
      <>
        {isError && <div className='row mb-2'>
          <div className='container-fluid'>
            <div className='col-12 text-white bg-dark p-12 m-0 mb-20'>
              <div className='align-items-center row  py-3'>
                <div className='col-md-2 col-3 text-center'>
                  <img src='/images/MyAccount/Icons/error-notification-icon.png'
                    className=''
                    alt='Temporarily Locked'
                    width='65'
                  />
                </div>
                <div className='col-md-10 col-9'>
                  {errTitle && <div className='row'>
                    <div className='col-12'>
                      <span className='tg-ft-20pt'>{errTitle}</span>
                    </div>
                  </div>}
                  <div className='row'>
                    <div className='col-12'>
                      <span className={errTitle ? 'tg-ft-15pt' : 'tg-ft-26pt'}>{message}</span>
                      
                      {
                        !isSavePrefError && 
                        <>
                          <br/>
                          <input type="button" onClick={() => window.location.reload()}
                              className="btn btn-lg btn-primary gfw-4 glh-1_2 w-50 mb-10 mt-2"
                              value='Try again' />
                        </>
                      }
                      
                    </div>                      
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
        {isSuccess && <div className='row'>
          <div className='container-fluid'>
            <div className='col-12 text-white bg-dark p-12 m-0 mb-20 '>
              <div className='align-items-center row'>
                <div className='col-12 col-md-2 text-center'>
                  <img src='/images/MyAccount/Icons/ico-success-notify.png' className='mb-5' alt='Temporarily Locked' width='65' />
                </div>
                <div className='col-12 col-md-10'>
                  <div className='row'>
                    <div className='col-12'>
                      <span className='tg-ft-26pt'>{labels.globalError.SUCCESS}</span>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <span className='tg-ft-20pt'>{message}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      </>
    );
}

export default ErrorMessage;